import React from "react"
import { Loader2 } from "lucide-react"

import SimpleMetric from "./SimpleMetric"
import BillableHoursCard from "./BillableHoursCard"
import { useSessionLatency } from "./hooks/useSessionLatency"
import CardSection from "./CardSection"

interface Props {
  username: string
  year: string
  quarter: number
  display: {
    SessionNoteAvg: boolean
    SessionNoteGraph: boolean
  }
}

const ClientDocumentationSection: React.FC<Props> = ({
  username,
  year,
  quarter,
  display,
}) => {
  const enabled =
    !!username &&
    !!year &&
    (display.SessionNoteAvg || display.SessionNoteGraph)

  const { graphData, average, loading } =
    useSessionLatency(username, year, quarter, enabled)

  if (!display.SessionNoteAvg && !display.SessionNoteGraph) {
    return null
  }

  return (
    <CardSection title="Client Documentation">
      {/* LEFT SIDE */}
      <div className="col-span-12 lg:col-span-4">
        {display.SessionNoteAvg && (
          loading ? (
            <div className="flex items-center gap-2 text-muted-foreground">
              <Loader2 className="h-5 w-5 animate-spin" />
              <span>Loading Session Latency...</span>
            </div>
          ) : (
            <SimpleMetric
              Title="Current Average Session Note Latency"
              Value={
                average == null
                  ? null
                  : average.toFixed(2)
              }
              Metric="Days"
              loading={false}
            />
          )
        )}
      </div>

      {/* RIGHT SIDE */}
      <div className="col-span-12 lg:col-span-8">
        {display.SessionNoteGraph && (
          loading ? (
            <div className="flex items-center gap-2 text-muted-foreground">
              <Loader2 className="h-5 w-5 animate-spin" />
              <span>Loading Session Latency...</span>
            </div>
          ) : (
            <BillableHoursCard
              title="Session Note Latency"
              data={graphData}
              loading={false}
              description="Weekly session note latency trend"
            />
          )
        )}
      </div>
    </CardSection>
  )
}

export default ClientDocumentationSection